<script>
import AvatarMenu from "@/components/custom/AvatarMenu.vue";
import { links } from "@/assets/static.js";

export default {
  name: "NavBar",
  components: {
    AvatarMenu,
  },
  data: () => ({
    CustomListMenudrawer: false,
    linksList: links,
  }),
};
</script>
<style>
@import "@/assets/css/navStyle.css";
</style>
<template>
  <v-sheet height="65px" id="app">
    <v-app-bar width="95%" dark color="prime" id="navBar" height="65px">
      <v-app-bar-nav-icon
        @click="drawer = true"
        class="d-flex d-sm-none"
      ></v-app-bar-nav-icon>
      <!-- <v-sheet
        class="transparent d-flex justify-space-between algin-center welcome_co"
      >
        <p class="ma-0 text-center pa-0 logo_text">
          Welcome Back! Infinity Sky Light
        </p>
        <v-avatar color="white" size="40"></v-avatar>
      </v-sheet> -->

      <!-- <v-divider color="orange" vertical class="mr-4"></v-divider> -->

      <template>
        <v-sheet
          width="21%"
          height="65%"
          class="d-flex justify-space-between algin-center welcome_co"
        >
          <v-card
            class="transparent d-flex align-center justify-end"
            width="60%"
            elevation="0"
            rounded="0"
          >
            <p class="ma-0 text-left pa-0 logo_text">
              Welcome Back! <br />
              Infinity Sky Light
            </p>
          </v-card>
          <v-card
            class="transparent d-flex align-center justify-center"
            width="40%"
            elevation="0"
            rounded="0"
          >
            <v-avatar color="white" size="40"></v-avatar>
          </v-card>
          <v-divider class="orange"></v-divider>
        </v-sheet>
        <v-tabs v-model="tab" class="d-md-flex d-none justify-space-around">
          <v-tabs-slider color="orange"></v-tabs-slider>
          <v-tab
            v-for="link in linksList"
            :key="link.id"
            :to="link.src"
            class="pa-0"
          >
            <p class="white--text mx-3 mb-0 link_name">
              {{ $t(link.name) }}
            </p>
          </v-tab>
        </v-tabs>
      </template>

      <template>
        <avatar-menu></avatar-menu>
      </template>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary id="menu-drawer">
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index) in linksList" :key="index">
            <v-list-item-title @click="tab = index">
              {{ $t(item.name) }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-content class="ma-5">
      <v-tabs-items v-model="tab" class="d-flex flex-column align-center">
        <v-tab-item v-for="item in items" :key="item">
          You are on {{ item }}
        </v-tab-item>
      </v-tabs-items>
    </v-content>
  </v-sheet>
</template>
